import eImg1 from '../images/events/eventsThumb1.jpg'
import eImg2 from '../images/events/eventsThumb2.jpg'

const Events = [
    {
        Id: '1',
        eImg: eImg1,
        title: 'events.1.title',         // DOĞRU: Flat değil, nested key!
        slug: 'the-human-rights-and-democracy-programme',
        date: 'events.1.date',           // Çeviriden!
        description: 'events.1.description',
    },
    {
        Id: '2',
        eImg: eImg2,
        title: 'events.2.title',
        slug: 'the-human-rights-and-democracy-programme',
        date: 'events.2.date',
        description: 'events.2.description',
    },
]

export default Events;
